if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;

        let europa = [
          "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
          "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT",
          "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL",
          "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI",
          "ES", "SE", "UA", "GB", "VA"
        ];
        
        this.form.addEventListener('submit', function(e) {
          e.preventDefault();
          let showLocationError = false;

          if(europa.indexOf(window.theme.location) === -1 && window.theme.usa_thresshold > 0) {
            showLocationError = true;
          }
          
          if(window.theme.location == "CH" && window.theme.ch_thresshold > 0) {
            showLocationError = true;
          }
          
          if(showLocationError) {
            this.onSubmitHandlerLocation(e);
          } else {
            this.onSubmitHandler(e);
          }
        }.bind(this));
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      setUpsellProductQty() {
        let upsellProduct = document.querySelector("[data-upsell]");
        let upsellProductId = upsellProduct.dataset.upsell;
        
        if(upsellProduct) {
          fetch('/cart.js', { method: 'GET', headers: {'Content-Type': 'application/json;'}})
          .then((response) => {
            return response.json();
          }).then((cartObject) => {
            let sum = 0;
            let key = "";
            
            window.theme.cart_total = cartObject.total_price;
            
            cartObject.items.forEach((el) => {
              if(el.id != upsellProductId) { 
                sum = 1;
              }
            });
            
            let updates = '?updates[' + upsellProductId + ']=' + sum;
            
            fetch('/cart/update.js' + updates, {
              method: 'POST'
            }).then(response => {
              this.updateCartContent();
              document.querySelector("cart-drawer-items").dispatchEvent(new Event('cart:refresh'));
              
            }).catch((error) => { });
          });
        }
      }
      
      updateCartContent(event) {
        fetch(window.Shopify.routes.root + "?sections=cart-drawer")
        .then((response) => response.json())
        .then((response) => {
          let selector = "#CartDrawer";
          let drawer = document.querySelector(selector)
          drawer.innerHTML = new DOMParser().parseFromString(response["cart-drawer"], 'text/html').querySelector(selector).innerHTML;
          window.Custom.initSlider(`.drawer__upsell .swiper`);
          window.Custom.setCheckoutUtm();
        });
      }
      
      manageSubsriptionData (formData) {
        let addOptionData = {};
        let addOption = document.querySelector(".additional-option:checked");
        
        let singleProduct = false;
        let annualProduct = false;
        
        if(addOption) {
          let addDetails = JSON.parse(document.querySelector("[data-addsubdetails]").dataset.addsubdetails);
          addOptionData = JSON.parse(addOption.dataset.details);
          formData.delete('id');
          formData.append('id', addOptionData.variant_id);
          formData.delete('product-id');
          formData.append('product-id', addOptionData.product_id);

          console.log(addOptionData);
          if (addOptionData.selling_plan) {
            formData.delete('selling_plan');
            formData.append('selling_plan', addOptionData.selling_plan);
          }

          if("690463310099,690196447507,690196480275".indexOf(addOptionData.selling_plan) > -1) {
            window.location.replace("/cart/clear");
          }
          
          if(addOptionData.cart_message) {
            formData.delete(`properties[${ window.theme.cart_message }]`);
            formData.append(`properties[${ window.theme.cart_message }]`, addOptionData.cart_message);
          }
          
          if(addOptionData.checkout_message) {
            formData.delete(`properties[${ window.theme.checkout_message }]`);
            formData.append(`properties[${ window.theme.checkout_message }]`, addOptionData.checkout_message);
          }

          if(!addOptionData.selling_plan) {
            singleProduct = true;
            formData.append(`properties[${ window.theme.product_type_key }]`, "Single");
          } else {
            formData.append(`properties[${ window.theme.product_type_key }]`, "Subscription");
            // formData.append('properties[_Subs]', "true");
          }
          
          if(addOptionData.qty) {
            formData.delete('quantity');
            formData.append('quantity', addOptionData.qty);
          }


          if(window.theme.annualPlanIds.indexOf(addOptionData.selling_plan) > -1) {
            annualProduct = true;
          }
        }
        
        return {formDataNew: formData, annualProduct: annualProduct, singleProduct: singleProduct};
      }
      
      onSubmitHandlerLocation(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let {formDataNew, annualProduct, singleProduct} = this.manageSubsriptionData(formData);
        formData = formDataNew;

        config.body = formData;
        
          for (const [key, value] of formData.entries()) {
  console.log(`${key}: ${value}`);
}
        fetch('/cart.js', { method: 'GET', headers: {'Content-Type': 'application/json;'}})
        .then((response) => {
          return response.json();
        }).then((cartObject) => {
          const total = cartObject.total_price;


          let threshold = window.theme.usa_thresshold * Number(Shopify.currency.rate);
          let threshold_text = window.theme.usa_thresshold_error;
          if(window.theme.location === "CH" && window.theme.ch_thresshold > 0) {
            threshold = window.theme.ch_thresshold * Number(Shopify.currency.rate);
            threshold_text = window.theme.ch_thresshold_error;
          }

          document.querySelector("[data-cart_popup]").closest("[data-popup-wrapper]").querySelector(".text--wrapper").textContent = threshold_text;
          
          console.log(total, window.theme.location);
          console.log("Total: ", cartObject, window.theme.cart_total);
          window.theme.cart_total = cartObject.total_price;
          
          const rate = Number(Shopify.currency.rate);
          const totalNormal = cartObject.items.reduce((sum, currentValue) => {
            if (currentValue.variant_title === "12-Month Supply") {
              return sum;
            } else {
              return sum + currentValue.line_price;
            }
          }, 0);

          let qty = 1;
          let productPrice = parseInt(document.querySelector(".additional-option:checked").closest("label").querySelector("[data-price]").dataset.price);

          // console.log(cartObject.items);
          // console.log(cartObject.items, totalNormal, annual);
          // console.log("productPrice: ", productPrice.toString(), productPrice.toString().length);
          // console.log("Totals: ", totalNormal, productPrice, qty);
          // console.log(window.theme.usa_thresshold, window.theme.usa_thresshold * rate);
          // console.log("Testing: ", (totalNormal + productPrice * qty), window.theme.usa_thresshold * rate, (totalNormal + productPrice * qty) > (window.theme.usa_thresshold * rate));

          console.log(threshold, window.theme.location, productPrice);
          
          if(!annualProduct) {
            if((totalNormal + productPrice * 1) > threshold) {
              document.querySelector("[data-cart_popup]").click();
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }
          }
          
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
              window.Custom.twitterConversion(response);
              
              window.Custom.initSlider(`.drawer__upsell .swiper`);
              window.Custom.cartUpsellAuto();
              window.Custom.setCheckoutUtm();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
          
        }).catch(() => { });
      }
        
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          
          this.cart.setActiveElement(document.activeElement);
        }
        
        // console.log(Object.fromEntries(formData.entries()));
        let {formDataNew, annualProduct, singleProduct} = this.manageSubsriptionData(formData);
        
        formData = formDataNew;
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            
            window.Custom.twitterConversion(response);
            
            window.Custom.initSlider(`.drawer__upsell .swiper`);
            window.Custom.cartUpsellAuto();
            window.Custom.setCheckoutUtm();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
